module.exports = __webpack_public_path__ + "static/media/FullLogo-New.a0f7d7d2.png";